module.exports = __webpack_public_path__ + "static/media/3.cc9c136d.png";